// addPeriodToTestss.js
import moment from 'moment';
import 'moment/locale/de';
import {updateObject} from '../utils/reducerUtils';

const LOCALE = 'de';
// If possible, we should also set this once in app bootstrap:
// moment.locale('nb');

const parseMomentLocalized = (v) => {
	if (v == null || v === 'undefined' || v === 'null') return null;

	if (typeof v === 'number') {
		const m = v < 1e12 ? moment.unix(v) : moment(v);
		return m.isValid() ? m.locale(LOCALE) : null;
	}

	let m = moment(v, moment.ISO_8601, true);
	if (!m.isValid()) m = moment(v);
	return m.isValid() ? m.locale(LOCALE) : null;
};

const addPeriodToTests = (row) => {
	const createdAt = parseMomentLocalized(row.createdAt);
	const distributedAt = parseMomentLocalized(row.distributedAt);
	const usedAt = parseMomentLocalized(row.usedAt);
	const completedAt = parseMomentLocalized(row.completedAt);

	const groupAt =
		distributedAt ||
		usedAt ||
		completedAt ||
		createdAt ||
		moment().locale(LOCALE);

	const safeCreatedAt = createdAt || groupAt;

	return updateObject(row, {
		createdAt: safeCreatedAt,
		distributedAt,
		usedAt,
		completedAt,
		groupAt,
	});
};

export default function addPeriodToTestss(rows) {
	return rows.map(addPeriodToTests);
}
